var map = {
	"./10C.jpg": "63c1",
	"./10D.jpg": "9ad5",
	"./10H.jpg": "e16e",
	"./10S.jpg": "8f47",
	"./2C.jpg": "8c4e",
	"./2D.jpg": "caa8",
	"./2H.jpg": "e41e",
	"./2S.jpg": "5047",
	"./3C.jpg": "919e",
	"./3D.jpg": "13a8",
	"./3H.jpg": "bc47",
	"./3S.jpg": "55eb",
	"./4C.jpg": "c100",
	"./4D.jpg": "7e31",
	"./4H.jpg": "30b7",
	"./4S.jpg": "8da8",
	"./5C.jpg": "d513",
	"./5D.jpg": "ba20",
	"./5H.jpg": "0627",
	"./5S.jpg": "0c55",
	"./6C.jpg": "d68b",
	"./6D.jpg": "bdd2",
	"./6H.jpg": "318e",
	"./6S.jpg": "1767",
	"./7C.jpg": "7869",
	"./7D.jpg": "9be6",
	"./7H.jpg": "68b4",
	"./7S.jpg": "e78f",
	"./8C.jpg": "2369",
	"./8D.jpg": "fa21",
	"./8H.jpg": "6f58",
	"./8S.jpg": "9f97",
	"./9C.jpg": "5bea",
	"./9D.jpg": "41da",
	"./9H.jpg": "c803",
	"./9S.jpg": "d38d",
	"./AC.jpg": "2f4e",
	"./AD.jpg": "5ffc",
	"./AH.jpg": "ae0b",
	"./AS.jpg": "78bb",
	"./Gray_back.jpg": "ce5f",
	"./Green_back.jpg": "01a9",
	"./JC.jpg": "bc79",
	"./JD.jpg": "5c42",
	"./JH.jpg": "f4af",
	"./JS.jpg": "0352",
	"./KC.jpg": "08ca",
	"./KD.jpg": "12d9",
	"./KH.jpg": "28e9",
	"./KS.jpg": "81cd",
	"./QC.jpg": "74bd",
	"./QD.jpg": "1b3f",
	"./QH.jpg": "d4b8",
	"./QS.jpg": "e2c6",
	"./Red_back.jpg": "e3b1",
	"./Yellow_back.jpg": "4bb0",
	"./blue_back.jpg": "56d4",
	"./purple_back.jpg": "accc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4729";